import DropdownButton from './DropdownButton'
import css from './styles.module.scss'
import classnames from 'classnames/bind'

const cx = classnames.bind(css)

const Dropdown = ({ children, isOpen, onToggle, buttonLabel }) => {
  return (
    <div className={cx(css.Dropdown, { [css.Dropdown]: isOpen })}>
      <DropdownButton onClick={onToggle} label={buttonLabel} isOpen={isOpen} />
      <ul
        className={cx({
          [css.OptionList]: isOpen,
          [css.Hidden]: !isOpen,
        })}
      >
        {children}
      </ul>
    </div>
  )
}

export default Dropdown
